export default __webpack_public_path__ + "static/where-to-travel-d-f6098be305ce7ffe649a662a09e8ef73.webp";